export const tooltipCfg = {
  color: 'var(--text-color)', // HEX only
  opacity: 1,
  backgroundColor: '#ffffff', // HEX only
  borderColor: 'var(--color-border)', // HEX only
  borderWidth: '1px',
  borderStyle: 'solid', // solid, dashed, dotted
  borderRadius: '2px',
  padding: '10px',
  maxWidth: '260px',
  headerFontSize: '15px',
  headerFontWeight: 500,
  headerMarginBottom: '5px',
  contentFontSize: '14px',
  contentFontWeight: 400,
  hideDelay: 25,
  letterSpacing: 0.5, // numbers only
};
